import React, { Component } from 'react';
import { Modal, Container, Tabs, Tab, Row, Col, Button, ProgressBar, Alert, ButtonToolbar } from 'react-bootstrap';
import { MdRemoveCircle } from 'react-icons/md'
import Courses, { Course, CourseResultFile } from '../../services/CoursesService';
//@ts-ignore
import FileUploader from '../../common/FileUploader'
import Utils from '../../services/Utils';

type UploadResultFilesProps = {
    isVisible?: boolean,
    isVisibleButtonAdd?: boolean,
    isVisibleButtonRemove?: boolean,
    courseId: number
}

type UploadResultFilesState = {
    isVisible?: boolean,
    loadedFiles: CourseResultFile[],
    uploadingInProgress: boolean,
    uploadingFile: any,
    uploadingProgress: number,
    showError: boolean,
    errorMessage: string
}

export default class UploadResultFiles extends Component<UploadResultFilesProps, UploadResultFilesState> {

    constructor(props: UploadResultFilesProps) {
        super(props);

        this.state = {
            isVisible: this.props.isVisible,
            loadedFiles: [],
            uploadingInProgress: false,
            uploadingFile: '',
            uploadingProgress: 0,
            showError: false,
            errorMessage: ''
        };

    }

    onStartUploading = (params: any) => {
        this.setState({
            uploadingInProgress: true,
            uploadingFile: params
        });
    }

    onUploadingProgress = (params: any) => {
        this.setState({
            uploadingProgress: params.percent
        });
    }

    onUploadingError = (params: any) => {        
        let errorMessage = params.response ? params.response : "Ошибка загрузки файла.";
        console.log(params);
        // i.DialogService.showDialog(MessageForm, {title: "Ошибка", message: err});
        this.setState({
            uploadingInProgress: false,
            uploadingProgress: 0,
            showError: true,
            errorMessage
        });
    }

    onUploadingSuccess = async (params: any) => {
        try{
            await Courses.createCourseResultFile({course: {id: this.props.courseId} as any, fileRecord: {id: params.fileRecordId}} as CourseResultFile);
            const loadedFiles = await Courses.getCourseResultFiles(this.props.courseId);
            this.setState({loadedFiles});
        } catch (err){
            let errorMessage = err.error ? err.error : "Ошибка загрузки файла.";
            this.setState({showError: true, errorMessage});
        }
        this.setState({
            uploadingInProgress: false,
            uploadingProgress: 0
        });
    }

    cancelUploading = () => {
        this.state.uploadingFile.cancelMethod();
        this.setState({
            uploadingFile: null,
            uploadingInProgress: false,
            uploadingProgress: 0
        })
    }

    async open(){
        const loadedFiles = await Courses.getCourseResultFiles(this.props.courseId);
        this.setState({isVisible: true, loadedFiles});
    }

    close(){
        this.setState({isVisible: false});
    }

    async onRemoveFile(file: CourseResultFile){
        try{
            await Courses.deleteCourseResultFile(file);
            const loadedFiles = this.state.loadedFiles.filter(f => f.id != file.id);
            this.setState({loadedFiles});
        } catch (err){
            let errorMessage = err.error ? err.error : "Ошибка удаления файла.";
            this.setState({showError: true, errorMessage});
        }
    }

    renderLoadedFiles(){
        return (
            <Row style={{marginBottom: '1em'}}>
                <Col>
                    <label style={{color: '#005AAA'}}>{'Загруженные файлы'}</label>
                    {this.state.loadedFiles.map((item, index: number) => (
                        <div style={{display: 'flex', alignItems: 'center'}} key={index}>
                            {this.props.isVisibleButtonRemove ? (
                                <MdRemoveCircle style={{fontSize: 20, marginRight: 10, cursor: 'pointer'}} onClick={() => this.onRemoveFile(item)} />
                            ) : null}
                            {item.fileRecord.originalFileName}
                            <span style={{marginLeft: 5, fontSize: '0.8em'}}>{'('}<a
                                download={item.fileRecord.originalFileName}
                                href={Utils.getFileUrl(item.fileRecord) as any}
                                title={item.fileRecord.originalFileName}
                                target={"_blank"}
                            >{'скачать'}</a>{')'}</span>
                        </div>
                    ))}
                    {this.state.uploadingInProgress ? (
                        <div style={{paddingTop: 6, paddingLeft: 0}}>
                            <ProgressBar now={this.state.uploadingProgress} label={`${this.state.uploadingProgress}%`} />
                        </div>)
                    : null}
                </Col>
            </Row>
        );
    }

    render(){
        return (
            <Modal show={this.state.isVisible} onHide={() => this.close()}>
                <Modal.Header closeButton>
                    <Modal.Title>{'Загрузка файлов'}</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Container>
                        {this.renderLoadedFiles()}
                        {this.state.showError ? (
                            <Alert variant='danger' onClose={() => this.setState({showError: false})} dismissible>
                                {this.state.errorMessage}
                            </Alert>) : null}
                    </Container>
                </Modal.Body>
                <Modal.Footer>
                    <FileUploader 
                        onStart={this.onStartUploading}
                        onProgress={this.onUploadingProgress}
                        onError={this.onUploadingError}
                        onSuccess={this.onUploadingSuccess}
                        >
                        <span>
                            {(!this.state.uploadingInProgress && this.props.isVisibleButtonAdd) ?
                                <Button>{'Добавить файл'}</Button>
                            : null}
                        </span>
                    </FileUploader>
                </Modal.Footer>
            </Modal>
        );
    }
}